import { EVENT_CATEGORY_OPTIONS } from 'hooks/orgEvents/orgEventAutomationHooks';

const PRESET_CATEGORY_VALUES = new Set<string>(
  EVENT_CATEGORY_OPTIONS.map((option) => option.value)
);

/** Selecting this preset reveals the custom category name. */
export const CUSTOM_CATEGORY_PRESET = 'Other';

export const SEVERITY_OPTIONS = ['High', 'Medium', 'Low'] as const;

export const DEFAULT_DUPLICATE_WINDOW_HOURS = 24;

/**
 * A saved category that is not a preset opens as Other with that name filled
 * in.
 */
export function categoryFieldsFromSaved(
  type: string | null | undefined,
  fallbackPreset: string
): { eventType: string; customCategory: string } {
  const saved = type?.trim() ?? '';
  if (!saved || PRESET_CATEGORY_VALUES.has(saved)) {
    return { eventType: saved || fallbackPreset, customCategory: '' };
  }
  return { eventType: CUSTOM_CATEGORY_PRESET, customCategory: saved };
}

/** The typed name is saved only when Other is selected. */
export function resolvedCategory(
  preset: string | undefined,
  custom: string | undefined
): string {
  const selected = preset?.trim() ?? '';
  if (selected === CUSTOM_CATEGORY_PRESET) {
    return custom?.trim() || CUSTOM_CATEGORY_PRESET;
  }
  return selected;
}

/** Missing or non-positive hours stay at the 24-hour default. */
export function duplicateWindowHoursFromSaved(value: unknown): number {
  const hours = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(hours) || hours <= 0)
    return DEFAULT_DUPLICATE_WINDOW_HOURS;
  return hours;
}
